
import Head from 'next/head'
import Script from 'next/script'
import { getPostBySlug, getWpNewPostsByCategory, getWpPostsByCategory } from "../../lib/service";
import Image from 'next/image';
import { s3Static } from '../../utils/constants';
import { BlogHeaderLinks } from '../../components/blogs/BlogHeaderLinks';

export const getStaticPaths = async () => {
    const posts = await getWpNewPostsByCategory(100, "general");
    const oldPosts = await getWpPostsByCategory(100, "general");

    posts.push(...oldPosts)

    return {
      paths: posts.map((post) => `/blogs/${post.slug}`),
      fallback: false,
    };
  };
  
export const getStaticProps = async ({ params }) => {
    const post = await getPostBySlug(params?.slug);
  
    return {
      props: { post },
    };
};

export default function Home({post}) {

  const description = post.excerpt.replace(/<[^>]+>/g, '').trim()

  return (
    <>
      <Head>
        <title>{post.title}</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"/>
        <meta name="description" content={description}/>
        <meta name="keywords" content="House Rental, Insurance Plan, Personal Trainer, Maid Service, Handyman Service, Aircon Service, Savings Plan, Food Catering, Interior Design, Wedding Planner, Event Planner"/>
        <meta name="author" content="StringsSG"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:url"  content={`https://www.stringssg.com/blogs/${post.slug}`} />
        <meta property="og:type"   content="article" />
        <meta property="og:title"    content={post.title}/>
        <meta property="og:description" content={description} />
        <meta property="article:publisher" content="https://www.facebook.com/StringsSG/" />
        <meta property="article:published_time" content={post.date} />
        <meta property="article:modified_time" content={post.modified} />
        <meta property="og:image"  content={post?.featuredImage?.node?.sourceUrl} />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content={post?.featuredImage?.node?.sourceUrl} />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content={`https://www.stringssg.com/blogs/${post.slug}`}/>
        <meta name="twitter:title" content={`Best Russian Restaurant & Food in Singapore`}/> 
        <meta name="twitter:description" content={description}/>
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href={`https://www.stringssg.com/blogs/${post.slug}`} />
        <script type="application/ld+json"
          dangerouslySetInnerHTML={{ __html:
            `{"@context":"https://schema.org","@graph":[{"@context":"https://schema.org/","@type":"BlogPosting","mainEntityOfPage":{"@type":"WebPage","@id":"${`https://www.stringssg.com/blogs/${post.slug}`}"},"headline":"${post.title}","description": "${description}","image":["${post?.featuredImage?.node?.sourceUrl}"],"author":{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG","url":"https://www.stringssg.com/"},"publisher":{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG","url":"https://www.stringssg.com/","logo":{"@type":"ImageObject","url":"https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/logo.png"}},"datePublished":"${post.date}","dateModified":"${post.modified}"},{"@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Blogs","item":"https://www.stringssg.com/blogs"},{"@type":"ListItem","position":2,"name":"${post.slug}"}]}]}`
          }}
        />
      </Head>
      <div>
        <section className="max-w-5xl mx-auto py-12">
            <div className='max-w-3xl mx-auto px-2 space-y-10'>
                <div className='relative h-96 w-full'>
                    <Image 
                        src={post.featuredImage?.node?.sourceUrl ?? s3Static + "logo.png"}
                        fill
                        style={{objectFit: 'cover'}}
                        placeholder='blur'
                        blurDataURL={s3Static + "placeholder.png"}
                        alt={post.featuredImage?.node?.sourceUrl ?? "StringsSG Logo"}
                        />
                </div>
                <div className='max-w-3xl mx-auto px-2 space-y-10'>
                    <h1 className="text-2xl md:text-3xl text-center font-bold">{post.title}</h1>
                    <div
                      className="post-content w-full px-2 mx-auto space-y-5 leading-8"
                      dangerouslySetInnerHTML={{ __html: post.content }}
                    ></div>
                </div>
            </div>
        </section>
        <BlogHeaderLinks/>
      </div>
      <Script 
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'G-QD1HGGHDYJ');
          }} 
      />
      <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
					  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
					  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
					  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
					  n.queue=[];t=b.createElement(e);t.async=!0;
					  t.src=v;s=b.getElementsByTagName(e)[0];
					  s.parentNode.insertBefore(t,s)}(window, document,'script',
					  'https://connect.facebook.net/en_US/fbevents.js');
					  fbq('init', '128634041116395');
					  fbq('track', 'PageView');`}
        </Script>
    </>
  )
}

